export class AuthSessionRequiredError extends Error {
  constructor() {
    super("auth_session_required");
    this.name = "AuthSessionRequiredError";
  }
}
